"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const standardized_audio_context_1 = require("standardized-audio-context");
const MicOutlined_1 = __importDefault(require("@material-ui/icons/MicOutlined"));
const styles_1 = require("@material-ui/core/styles");
const FilledSVG_1 = __importDefault(require("../FilledSVG"));
const styles_2 = __importDefault(require("./styles"));
let audioContext;
const VolumeIndicator = ({ track, id, }) => {
    // volume level from 0 to 100
    const classes = styles_2.default();
    const [level, setLevel] = react_1.useState(0);
    const [workerState, setWorkerState] = react_1.useState();
    const theme = styles_1.useTheme();
    react_1.useEffect(() => {
        Promise.resolve()
            .then(async () => {
            if (!audioContext) {
                audioContext = new standardized_audio_context_1.AudioContext();
                await audioContext.audioWorklet.addModule('/worker/volume-processor.worker.js');
            }
            const volumeNode = new standardized_audio_context_1.AudioWorkletNode(audioContext, 'volume-processor');
            const source = audioContext.createMediaStreamTrackSource(track.mediaStreamTrack);
            volumeNode.port.onmessage = (event) => {
                setLevel(event.data);
            };
            source.connect(volumeNode);
            setWorkerState({
                source,
                worker: volumeNode,
            });
        })
            .catch(console.error);
        return () => {
            if (track) {
                setWorkerState(null);
            }
        };
    }, [track]);
    react_1.useEffect(() => {
        return () => {
            var _a, _b, _c, _d, _e;
            if (workerState) {
                (_a = workerState.worker) === null || _a === void 0 ? void 0 : _a.port.postMessage(false);
                (_b = workerState.worker) === null || _b === void 0 ? void 0 : _b.port.removeEventListener('message', () => { });
                (_c = workerState.worker) === null || _c === void 0 ? void 0 : _c.port.removeEventListener('messageerror', () => { });
                (_d = workerState.worker) === null || _d === void 0 ? void 0 : _d.disconnect();
                (_e = workerState.source) === null || _e === void 0 ? void 0 : _e.disconnect();
            }
        };
    }, [workerState]);
    return (react_1.default.createElement(FilledSVG_1.default, { id: `mic-volume-indicator-${id}`, fill: level, fillColor: theme.palette.secondary.main, stopColor: theme.palette.common.white },
        react_1.default.createElement(MicOutlined_1.default, { classes: {
                root: classes.root,
            } })));
};
exports.default = VolumeIndicator;
